import { render, staticRenderFns } from "./inductModal.vue?vue&type=template&id=6c8c8eed&"
import script from "./inductModal.vue?vue&type=script&lang=js&"
export * from "./inductModal.vue?vue&type=script&lang=js&"
import style0 from "./inductModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports